module.exports = __webpack_public_path__ + "img/geotab.57a6f840.svg";